<div class="copy-confirmation-container">
    <h1 class="dialog-title">Copy Template Confirmation</h1>
    <div *ngIf="data" class="dialog-content">
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <mat-form-field>
                    <input
                        [(ngModel)]="data.name"
                        aria-label="New Name"
                        autocomplete="off"
                        matInput
                        placeholder="New Name"
                    />
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="dialog-actions">
        <button
            (click)="onCopyClick()"
            class="mr-1"
            color="green"
            mat-stroked-button
        >
            <mat-icon>file_copy</mat-icon>
            Copy
        </button>
        <button (click)="onCancelClick()" mat-stroked-button>Cancel</button>&nbsp;
    </div>
</div>
